module.exports = __webpack_public_path__ + "img/newest-shipments-no-data.6ce59708.png";